import { render } from "./TopBannerAlert.vue?vue&type=template&id=34f415c9&scoped=true"
import script from "./TopBannerAlert.vue?vue&type=script&lang=js"
export * from "./TopBannerAlert.vue?vue&type=script&lang=js"

import "./TopBannerAlert.vue?vue&type=style&index=0&id=34f415c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f415c9"]])

export default __exports__